import { render, staticRenderFns } from "./historia.vue?vue&type=template&id=4ea350ba&scoped=true&"
var script = {}
import style0 from "./historia.vue?vue&type=style&index=0&id=4ea350ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea350ba",
  null
  
)

export default component.exports